export const SEAT_COLORS = ["#FF6B5B", "#2ED3B7", "#F7B32B", "#8C7CFF"];
